// export { default } from "./AddRolesPermissionsForm";
//
// Role access is defined per module by five independent flags:
//   view   — can see the page / it appears in the nav      (viewRoutes)
//   read   — can call the read (GET) API                    (no routes)
//   add    — can create                                     (addRoutes,  /add-*)
//   edit   — can update + run mutating actions              (editRoutes, /update-*)
//   delete — can delete                                     (deleteRoutes)
//
// `read` was split into view + read, and `write` into add + edit. A `null`
// flag means that column does not apply to the module (renders no checkbox).
export interface Permissions {
  name: String;
  view: Boolean | null;
  read: Boolean | null;
  add: Boolean | null;
  edit: Boolean | null;
  delete: Boolean | null;
  viewRoutes: any[];
  addRoutes: any[];
  editRoutes: any[];
  deleteRoutes: any[];
}

export const permissionCheckList = [
  {
    name: "dashboard",
    view: false,
    read: false,
    add: null,
    edit: null,
    delete: null,
    viewRoutes: ["/dashboard"],
    addRoutes: [],
    editRoutes: [],
    deleteRoutes: [],
  },
  {
    name: "revenue_report",
    view: false,
    read: false,
    add: null,
    edit: null,
    delete: null,
    viewRoutes: ["/revenue-report"],
    addRoutes: [],
    editRoutes: [],
    deleteRoutes: [],
  },
  {
    name: "trip",
    view: false,
    read: false,
    add: false,
    edit: false,
    delete: false,
    viewRoutes: [
      "/bookings",
      "/booking-details/:id",
      "/events",
      "/event-details/:id",
      "/booking-ratings",
    ],
    addRoutes: ["/add-booking", "/add-script"],
    editRoutes: ["/update-booking/:id", "/update-script/:id"],
    deleteRoutes: [],
  },
  {
    name: "calendar",
    view: false,
    read: false,
    add: null,
    edit: null,
    delete: null,
    viewRoutes: ["/calendar"],
    addRoutes: [],
    editRoutes: [],
    deleteRoutes: [],
  },
  {
    name: "user",
    view: false,
    read: false,
    add: false,
    edit: false,
    delete: false,
    viewRoutes: ["/users", "/user-details/:id", "/user-points/:id"],
    addRoutes: ["/add-user"],
    editRoutes: [],
    deleteRoutes: [],
  },
  {
    name: "driver",
    view: false,
    read: false,
    add: false,
    edit: false,
    delete: false,
    viewRoutes: ["/chauffeurs", "/chauffeur-details/:id"],
    addRoutes: ["/add-chauffeur", "/add-group-tracking"],
    editRoutes: ["/update-chauffeur/:id", "/update-group-tracking/:id"],
    deleteRoutes: [],
  },
  {
    name: "vehicle",
    view: false,
    read: false,
    add: false,
    edit: false,
    delete: false,
    viewRoutes: ["/vehicles", "/vehicle-details/:id"],
    addRoutes: ["/add-vehicle"],
    editRoutes: ["/update-vehicle/:id"],
    deleteRoutes: [],
  },
  {
    name: "model",
    view: false,
    read: false,
    add: false,
    edit: false,
    delete: false,
    viewRoutes: ["/models"],
    addRoutes: ["/add-model"],
    editRoutes: ["/update-model/:id"],
    deleteRoutes: [],
  },
  {
    name: "class",
    view: false,
    read: false,
    add: false,
    edit: false,
    delete: false,
    viewRoutes: ["/class"],
    addRoutes: ["/add-class"],
    editRoutes: ["/update-class/:id"],
    deleteRoutes: [],
  },
  {
    name: "notification",
    view: false,
    read: false,
    add: false,
    edit: false,
    delete: false,
    viewRoutes: ["/Notifications"],
    addRoutes: ["/send-push-notification"],
    editRoutes: ["/update-push-notification/:id"],
    deleteRoutes: [],
  },
  {
    name: "availability",
    view: false,
    read: false,
    add: false,
    edit: false,
    delete: false,
    viewRoutes: ["/availability"],
    addRoutes: [],
    editRoutes: [],
    deleteRoutes: [],
  },
  {
    name: "zone",
    view: false,
    read: false,
    add: false,
    edit: false,
    delete: false,
    viewRoutes: ["/Zone"],
    addRoutes: ["/add-zone"],
    editRoutes: ["/update-zone/:id"],
    deleteRoutes: [],
  },
  {
    name: "partner",
    view: false,
    read: false,
    add: false,
    edit: false,
    delete: false,
    viewRoutes: ["/partners", "/partner-details/:id"],
    addRoutes: ["/add-partner"],
    editRoutes: ["/update-partner/:id"],
    deleteRoutes: [],
  },
  {
    name: "partner_requests",
    view: false,
    read: false,
    add: false,
    edit: false,
    delete: false,
    viewRoutes: ["/partner-requests"],
    addRoutes: [],
    editRoutes: [],
    deleteRoutes: [],
  },
  {
    name: "company",
    view: false,
    read: false,
    add: false,
    edit: false,
    delete: false,
    viewRoutes: ["/companies", "/company-details/:id"],
    addRoutes: ["/add-company", "/add-company-user"],
    editRoutes: ["/update-company/:id"],
    deleteRoutes: [],
  },
  {
    name: "company_requests",
    view: false,
    read: false,
    add: false,
    edit: false,
    delete: false,
    viewRoutes: ["/company-requests"],
    addRoutes: [],
    editRoutes: [],
    deleteRoutes: [],
  },
  {
    name: "campaign",
    view: false,
    read: false,
    add: false,
    edit: false,
    delete: false,
    viewRoutes: ["/campaigns", "/campaign-details/:id"],
    addRoutes: ["/add-campaign"],
    editRoutes: ["/update-campaign/:id"],
    deleteRoutes: [],
  },
  {
    name: "price",
    view: false,
    read: false,
    add: false,
    edit: false,
    delete: false,
    viewRoutes: ["/pricing", "/pricing-engine"],
    addRoutes: ["/add-pricing", "/add-pricing-engine"],
    editRoutes: ["/update-pricing/:id", "/update-pricing-engine/:id"],
    deleteRoutes: [],
  },
  {
    name: "invoice",
    view: false,
    read: false,
    add: false,
    edit: false,
    delete: false,
    viewRoutes: ["/partner-invoices", "/company-invoices", "/customer-invoices"],
    addRoutes: ["/add-invoices"],
    editRoutes: [],
    deleteRoutes: [],
  },
  {
    name: "contact",
    view: false,
    read: false,
    add: false,
    edit: false,
    delete: false,
    viewRoutes: ["/contacts"],
    addRoutes: [],
    editRoutes: [],
    deleteRoutes: [],
  },
  {
    name: "request_history",
    view: false,
    read: false,
    add: null,
    edit: null,
    delete: null,
    viewRoutes: ["/search-history"],
    addRoutes: [],
    editRoutes: [],
    deleteRoutes: [],
  },
  {
    name: "report",
    view: false,
    read: false,
    add: false,
    edit: false,
    delete: false,
    viewRoutes: ["/reported-problems"],
    addRoutes: [],
    editRoutes: [],
    deleteRoutes: [],
  },
  {
    name: "dynamics",
    view: false,
    read: false,
    add: false,
    edit: false,
    delete: false,
    viewRoutes: ["/dynamics"],
    addRoutes: [],
    editRoutes: [],
    deleteRoutes: [],
  },
  {
    name: "role",
    view: false,
    read: false,
    add: false,
    edit: false,
    delete: false,
    viewRoutes: ["/roles", "/update-role/:id"],
    addRoutes: ["/add-role", "/add-role-permission"],
    editRoutes: ["/update-role-permission/:id"],
    deleteRoutes: [],
  },
  {
    name: "car_movement",
    view: false,
    read: false,
    add: false,
    edit: false,
    delete: false,
    viewRoutes: ["/car-movement"],
    addRoutes: ["/add-car-movement"],
    editRoutes: ["/update-car-movement/:id"],
    deleteRoutes: [],
  },
  {
    name: "commission",
    view: false,
    read: false,
    add: false,
    edit: false,
    delete: false,
    viewRoutes: ["/commission"],
    addRoutes: [],
    editRoutes: [],
    deleteRoutes: [],
  },
  {
    name: "fuel",
    view: false,
    read: false,
    add: null,
    edit: null,
    delete: null,
    viewRoutes: ["/fuels"],
    addRoutes: [],
    editRoutes: [],
    deleteRoutes: [],
  },
  {
    name: "payment_link",
    view: false,
    read: false,
    add: false,
    edit: false,
    delete: null,
    viewRoutes: ["/payment-link"],
    addRoutes: ["/add-payment-link"],
    editRoutes: [],
    deleteRoutes: [],
  },
  {
    name: "fixed_price",
    view: false,
    read: false,
    add: false,
    edit: false,
    delete: null,
    viewRoutes: [],
    addRoutes: ["/add-fixed-price"],
    editRoutes: ["/update-fixed-price/:id"],
    deleteRoutes: [],
  },
  {
    name: "location_price",
    view: false,
    read: false,
    add: false,
    edit: false,
    delete: null,
    viewRoutes: ["/location-prices"],
    addRoutes: ["/add-location-price"],
    editRoutes: ["/update-location-price/:id"],
    deleteRoutes: [],
  },
  {
    name: "special_price",
    view: false,
    read: false,
    add: false,
    edit: false,
    delete: false,
    viewRoutes: ["/special-prices"],
    addRoutes: ["/add-special-price"],
    editRoutes: [],
    deleteRoutes: [],
  },
  {
    name: "traffic_violation",
    view: false,
    read: false,
    add: false,
    edit: false,
    delete: null,
    viewRoutes: ["/traffic-violations"],
    addRoutes: ["/add-traffic-violation"],
    editRoutes: ["/update-traffic-violation/:id"],
    deleteRoutes: [],
  },
  {
    name: "quotation",
    view: false,
    read: false,
    add: false,
    edit: false,
    delete: null,
    viewRoutes: ["/rfqs"],
    addRoutes: ["/add-rfq"],
    editRoutes: ["/update-rfq/:id"],
    deleteRoutes: [],
  },
  {
    name: "delivery_car_model",
    view: false,
    read: false,
    add: false,
    edit: false,
    delete: false,
    viewRoutes: ["/delivery-car-models", "/delivery-car-model-details/:id"],
    addRoutes: ["/add-delivery-car-model"],
    editRoutes: ["/update-delivery-car-model/:id"],
    deleteRoutes: [],
  },
  {
    name: "delivery_car_category",
    view: false,
    read: false,
    add: false,
    edit: false,
    delete: false,
    viewRoutes: ["/delivery-car-categories"],
    addRoutes: [],
    editRoutes: [],
    deleteRoutes: [],
  },
  {
    name: "delivery_car",
    view: false,
    read: false,
    add: false,
    edit: false,
    delete: false,
    viewRoutes: ["/delivery-cars", "/delivery-car-details/:id"],
    addRoutes: ["/add-delivery-car"],
    editRoutes: ["/update-delivery-car/:id"],
    deleteRoutes: [],
  },
  {
    name: "delivery_booking",
    view: false,
    read: false,
    add: false,
    edit: false,
    delete: false,
    viewRoutes: ["/delivery-bookings", "/delivery-booking-details/:id"],
    addRoutes: ["/add-delivery-booking"],
    editRoutes: ["/update-delivery-booking/:id"],
    deleteRoutes: [],
  },
  {
    name: "delivery_car_extra",
    view: false,
    read: false,
    add: false,
    edit: false,
    delete: false,
    viewRoutes: ["/delivery-car-extras"],
    addRoutes: [],
    editRoutes: [],
    deleteRoutes: [],
  },
  {
    name: "delivery_car_insurance",
    view: false,
    read: false,
    add: false,
    edit: false,
    delete: false,
    viewRoutes: ["/delivery-car-insurances"],
    addRoutes: ["/add-delivery-car-insurance"],
    editRoutes: ["/update-delivery-car-insurance/:id"],
    deleteRoutes: [],
  },
  {
    name: "delivery_branch",
    view: false,
    read: false,
    add: false,
    edit: false,
    delete: false,
    viewRoutes: ["/delivery-branches", "/delivery-branch-details/:id"],
    addRoutes: ["/add-delivery-branch"],
    editRoutes: ["/update-delivery-branch/:id"],
    deleteRoutes: [],
  },
  {
    name: "digital_contract",
    view: false,
    read: false,
    add: false,
    edit: false,
    delete: null,
    viewRoutes: ["/digital-contracts"],
    addRoutes: ["/add-digital-contract"],
    editRoutes: ["/update-digital-contract/:id"],
    deleteRoutes: [],
  },
  {
    name: "asset_management",
    view: false,
    read: false,
    add: false,
    edit: false,
    delete: false,
    viewRoutes: ["/asset-management"],
    addRoutes: ["/add-asset"],
    editRoutes: ["/update-asset/:id"],
    deleteRoutes: [],
  },
  {
    name: "e_car",
    view: false,
    read: false,
    add: false,
    edit: false,
    delete: false,
    viewRoutes: ["/e-cars"],
    addRoutes: ["/add-e-car"],
    editRoutes: ["/update-e-car/:id"],
    deleteRoutes: [],
  },
];

export interface IRoute {
  path: string;
  name: string;
}
